import axios from "axios";
import { getDeviceHeaders } from "./device";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = `${BACKEND_URL}/api`;

const TOKEN_KEY = "tnpm_token";
const USER_KEY = "tnpm_user";
const DEVICE_STATUS_KEY = "pmc.device.status";

export const tokenStore = {
  get() {
    return localStorage.getItem(TOKEN_KEY);
  },
  set(t) {
    localStorage.setItem(TOKEN_KEY, t);
  },
  clear() {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },
};

export const userStore = {
  get() {
    try {
      return JSON.parse(localStorage.getItem(USER_KEY) || "null");
    } catch {
      return null;
    }
  },
  set(u) {
    localStorage.setItem(USER_KEY, JSON.stringify(u));
  },
};

/**
 * Persisted device-binding status for the current login session. Lets
 * any page in the app know whether the current device has been admin-
 * approved for sensitive writes (attendance capture, hourly selfie).
 * Possible values: "approved", "pending", "revoked", "not_required".
 */
export const deviceStatusStore = {
  get() {
    try { return localStorage.getItem(DEVICE_STATUS_KEY); } catch { return null; }
  },
  set(s) {
    if (!s) { try { localStorage.removeItem(DEVICE_STATUS_KEY); } catch { /* ignore */ } return; }
    try { localStorage.setItem(DEVICE_STATUS_KEY, s); } catch { /* ignore */ }
  },
  clear() {
    try { localStorage.removeItem(DEVICE_STATUS_KEY); } catch { /* ignore */ }
  },
};

export const api = axios.create({
  baseURL: API_BASE,
  timeout: 60000,
});

api.interceptors.request.use((cfg) => {
  const t = tokenStore.get();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  // Always send device identity headers so the backend can recognise this
  // physical device on every call (not just at login). Headers are
  // cheap — UUID from localStorage and the cached fingerprint hash.
  Object.assign(cfg.headers, getDeviceHeaders());
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      tokenStore.clear();
      deviceStatusStore.clear();
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/login")) {
        window.location.assign("/login");
      }
    }
    // Surface device-binding rejections so the UI can prompt the user
    // to submit a selfie unlock request.
    if (err?.response?.status === 423 && err?.response?.data?.detail?.code === "device_not_approved") {
      const ds = err.response.data.detail.device_status || "pending";
      deviceStatusStore.set(ds);
    }
    return Promise.reject(err);
  },
);
